<ambita-cadastre-report-addresses>
  <div class="ambita-cadastre-report__section ambita-cadastre-report__addresses" id="ambita-cadastre-report__addresses"
       if="{ data }">
    <h4 class="ambita-cadastre-report__section-title ambita-report-h4">{ i18n.propertyLookup.titleAddresses }</h4>
    <div class="ambita-cadastre-report__addresses-district" each="{ district in data.districts }">
      <div class="ambita-cadastre-report-clearfix">
        <ul class="ambita-cadastre-report__document-output ambita-cadastre-report-2col ambita-report-ul">
          <li>
            <span class="ambita-cadastre-report__document-output-title">
              { i18n.propertyLookup.districtMunicipality }
            </span>
            <span class="ambita-cadastre-report__document-output-part">{ district.municipalityNumber }</span>
            <span class="ambita-cadastre-report__document-output-value">{ district.municipalityName }</span>
          </li>
          <li>
            <span class="ambita-cadastre-report__document-output-title">
              { i18n.propertyLookup.districtStatisticalUnit }
            </span>
            <span class="ambita-cadastre-report__document-output-part">{ district.statisticalUnitNumber }</span>
            <span class="ambita-cadastre-report__document-output-value">{ district.statisticalUnitName }</span>
          </li>
          <li>
            <span class="ambita-cadastre-report__document-output-title">{ i18n.propertyLookup.districtParish }</span>
            <span class="ambita-cadastre-report__document-output-part">{ district.parishNumber }</span>
            <span class="ambita-cadastre-report__document-output-value">{ district.parishName }</span>
          </li>
        </ul>

        <ul class="ambita-cadastre-report__document-output ambita-cadastre-report-2col ambita-report-ul">
          <li if="{ district.borough }">
            <span class="ambita-cadastre-report__document-output-title">{ i18n.propertyLookup.districtBorough }</span>
            <span class="ambita-cadastre-report__document-output-part">{ district.boroughNumber }</span>
            <span class="ambita-cadastre-report__document-output-value">{ district.boroughName }</span>
          </li>
          <li if="{ !district.borough }"><span>&nbsp;</span></li>
          <li>
            <span class="ambita-cadastre-report__document-output-title">
              { i18n.propertyLookup.districtElectoralDistrict }
            </span>
            <span class="ambita-cadastre-report__document-output-part">{ district.electoralDistrictNumber }</span>
            <span class="ambita-cadastre-report__document-output-value">{ district.electoralDistrictName }</span>
          </li>
          <li if="{ district.urbanArea }">
            <span class="ambita-cadastre-report__document-output-title">{ i18n.propertyLookup.districtUrbanArea }</span>
            <span class="ambita-cadastre-report__document-output-part">{ district.urbanAreaNumber }</span>
            <span class="ambita-cadastre-report__document-output-value">{ district.urbanAreaName }</span>
          </li>
        </ul>
      </div>
      <div class="ambita-cadastre-report__sub-section--collapsible
                { ambita-cadastre-report__sub-section--collapsed: district.addresses.length > 5 }">
        <header class="ambita-cadastre-report__sub-section-header" onclick="{ collapse }">
          <i class="ambita-cadastre-report__sub-section-arrow"></i>
          <h5 class="ambita-cadastre-report__sub-section-title ambita-report-h5">
            { district.addresses.length } { district.addresses.length > 1 ? i18n.propertyLookup.unitAddresses :
            i18n.propertyLookup.unitAddress }
          </h5>
        </header>
        <div class="ambita-cadastre-report__sub-section-content">
          <table class="ambita-cadastre-report__list">
            <thead class="ambita-cadastre-report__header">
            <tr class="ambita-cadastre-report__row">
              <th>{ i18n.propertyLookup.unitAddresses }</th>
              <th>{ i18n.propertyLookup.addressUpdated }</th>
              <th>{ i18n.propertyLookup.coordSystem }</th>
              <th>{ i18n.propertyLookup.coordX }</th>
              <th>{ i18n.propertyLookup.coordY }</th>
            </tr>
            </thead>
            <tbody>
            <tr class="ambita-cadastre-report__row" each="{ address in district.addresses }">
              <td>{ address.longStreetAddress || address.cadastreAddress }</td>
              <td>{ address.updatedDate }</td>
              <td>23</td>
              <td>{ address.coordinates[1] }</td>
              <td>{ address.coordinates[0] }</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <p if="{ !data.districts }">{ i18n.propertyLookup.titleNoAddresses }</p>
  </div>
  <script>
    import { init } from './sectionController';

    init(this);
  </script>
</ambita-cadastre-report-addresses>
